/* eslint-disable */
// biome-ignore-all lint: auto-generated
// biome-ignore-all format: auto-generated
// biome-ignore-all assist: auto-generated
//
// This file is auto-generated by build/build.js.
// Do not modify manually, please do: bun run build:minimap.
//

export const enum DefaultMinimap {
  fd_close = "1",
  fd_write = "2",
  fd_read = "3",
  fd_seek = "4",
  environ_get = "5",
  environ_sizes_get = "6",
  proc_exit = "7",
  fd_pread = "8",
  fd_pwrite = "9",
  clock_time_get = "a",
  _tzset_js = "b",
  _localtime_js = "c",
  _gmtime_js = "d",
  __syscall_fcntl64 = "e",
  __syscall_ioctl = "f",
  __syscall_openat = "g",
  __syscall_stat64 = "h",
  __syscall_unlinkat = "i",
  __syscall_rmdir = "j",
  __syscall_getdents64 = "k",
  _emscripten_runtime_keepalive_clear = "l",
  _setitimer_js = "m",
  emscripten_resize_heap = "n",
  emscripten_date_now = "o",
  _abort_js = "p",
  _emscripten_throw_longjmp = "q",
  __syscall_getcwd = "r",
  __assert_fail = "s",
  __syscall_dup = "t",
  __syscall_dup3 = "u",
  __syscall_fstat64 = "v",
  __syscall_lstat64 = "w",
  __syscall_newfstatat = "x",
  __syscall_renameat = "y",
  __cxa_throw = "z",
  exit = "10",
  log_str = "11",
  env = "12",
  wasi_snapshot_preview1 = "13",
  memory = "14",
  __indirect_function_table = "15",
  __wasm_call_ctors = "16",
  setThrew = "17",
  emscripten_stack_get_current = "18",
  _emscripten_stack_restore = "19",
  malloc = "1a",
  free = "1b",
  invoke_ii = "1c",
  invoke_iii = "1d",
  invoke_iiii = "1e",
  invoke_iiiii = "1f",
  invoke_iiiiii = "1g",
  invoke_iiiiiii = "1h",
  invoke_iiiiiiii = "1i",
  invoke_iiiiiiiii = "1j",
  invoke_iiiiiiiiii = "1k",
  invoke_iiiiiiiiiiii = "1l",
  invoke_v = "1m",
  invoke_vi = "1n",
  invoke_vii = "1o",
  invoke_viii = "1p",
  invoke_viiii = "1q",
  invoke_viiiii = "1r",
  invoke_viiiiii = "1s",
  invoke_viiiiiii = "1t",
  invoke_viiiiiiii = "1u",
  invoke_viiiiiiiii = "1v",
  invoke_iiji = "1w",
  invoke_iji = "1x",
  invoke_jji = "1y",
  invoke_jiji = "1z",
  invoke_iij = "20",
  invoke_jii = "21",
  invoke_ji = "22",
  invoke_diiid = "23",
  invoke_iidi = "24",
  invoke_iddii = "25",
  invoke_iiiiiij = "26",
  invoke_iiiiiiiiiijj = "27",
  invoke_iiiiiiiiiiji = "28",
  invoke_iiiiiiijjii = "29",
  invoke_iijiii = "2a",
  invoke_iiijiii = "2b",
  invoke_iiiijj = "2c",
  invoke_iidiii = "2d",
  invoke_fdi = "2e",
  invoke_idii = "2f",
  invoke_iiiiiiiifi = "2g",
  invoke_vijii = "2h",
  invoke_iiiijii = "2i",
  invoke_iiiiijiiiii = "2j",
  invoke_fdii = "2k",
  invoke_viiiiiiiiijiiii = "2l",
  invoke_id = "2m",
  invoke_dd = "2n",
  invoke_viij = "2o",
  invoke_fdd = "2p",
  invoke_iiiij = "2q",
  invoke_iiiiijiiii = "2r",
  invoke_iiijii = "2s",
  invoke_iiiijiiii = "2t",
  invoke_iiiji = "2u",
  invoke_iidiiii = "2v",
  invoke_iijii = "2w",
  invoke_iijj = "2x",
  invoke_iijjjjjj = "2y",
  invoke_viiiiiiiiiiiiiijiiiii = "2z",
  invoke_viiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiijiiiiii = "30",
  invoke_iiiiiiiiiiiiiiiii = "31",
  invoke_iiiiiiiiiiiiii = "32",
  invoke_iiiiiiiiiiiii = "33",
  invoke_iiiiiiiiiiiiiiii = "34",
  invoke_iiiiiiiiiii = "35",
  invoke_iiiiiiiiiiiiiii = "36",
  invoke_djijd = "37",
  invoke_fdj = "38",
  invoke_fdjj = "39",
  invoke_iddjj = "3a",
  invoke_idjj = "3b",
  invoke_iidjjj = "3c",
  invoke_iijjj = "3d",
  invoke_ij = "3e",
  invoke_ijdj = "3f",
  invoke_ijii = "3g",
  invoke_ijiii = "3h",
  invoke_ijiiii = "3i",
  invoke_ijiiiiiii = "3j",
  invoke_ijiiiiiiji = "3k",
  invoke_ijiiiij = "3l",
  invoke_ijiiiijiii = "3m",
  invoke_ijiiiijij = "3n",
  invoke_ijiiij = "3o",
  invoke_ijiiijjiiiiii = "3p",
  invoke_ijiij = "3q",
  invoke_ijiiji = "3r",
  invoke_ijiijj = "3s",
  invoke_ijij = "3t",
  invoke_ijiji = "3u",
  invoke_ijijijj = "3v",
  invoke_ijijj = "3w",
  invoke_ijijjj = "3x",
  invoke_ijijjjj = "3y",
  invoke_ijj = "3z",
  invoke_ijji = "40",
  invoke_ijjii = "41",
  invoke_ijjiiiij = "42",
  invoke_ijjiiiijjii = "43",
  invoke_ijjiiij = "44",
  invoke_ijjiiijjji = "45",
  invoke_ijjiij = "46",
  invoke_ijjiijiiii = "47",
  invoke_ijjiijiiiii = "48",
  invoke_ijjiijiiiiji = "49",
  invoke_ijjiijiiiijii = "4a",
  invoke_ijjiijiiiijiij = "4b",
  invoke_ijjiijiiiijj = "4c",
  invoke_ijjiijjjjiiiiiiii = "4d",
  invoke_ijjiijjjjjjjiiii = "4e",
  invoke_ijjij = "4f",
  invoke_ijjiji = "4g",
  invoke_ijjijiii = "4h",
  invoke_ijjijj = "4i",
  invoke_ijjijjj = "4j",
  invoke_ijjj = "4k",
  invoke_ijjji = "4l",
  invoke_ijjjii = "4m",
  invoke_ijjjiiiiiiii = "4n",
  invoke_ijjjiiiji = "4o",
  invoke_ijjjiiijj = "4p",
  invoke_ijjjij = "4q",
  invoke_ijjjijj = "4r",
  invoke_ijjjijji = "4s",
  invoke_ijjjj = "4t",
  invoke_ijjjji = "4u",
  invoke_ijjjjii = "4v",
  invoke_ijjjjj = "4w",
  invoke_ijjjjji = "4x",
  invoke_ijjjjjij = "4y",
  invoke_ijjjjjj = "4z",
  invoke_ijjjjjji = "50",
  invoke_ijjjjjjiij = "51",
  invoke_ijjjjjjijii = "52",
  invoke_ijjjjjjj = "53",
  invoke_ijjjjjjjfj = "54",
  invoke_ijjjjjjjj = "55",
  invoke_ijjjjjjjji = "56",
  invoke_ijjjjjjjjj = "57",
  invoke_ijjjjjjjjjj = "58",
  invoke_ijjjjjjjjjjj = "59",
  invoke_ijjjjjjjjjjjjj = "5a",
  invoke_ijjjjjjjjjjjjjj = "5b",
  invoke_jj = "5c",
  invoke_jjii = "5d",
  invoke_jjiii = "5e",
  invoke_jjiiiii = "5f",
  invoke_jjiijj = "5g",
  invoke_jjij = "5h",
  invoke_jjijjjji = "5i",
  invoke_jjj = "5j",
  invoke_jjji = "5k",
  invoke_jjjiii = "5l",
  invoke_jjjiijjj = "5m",
  invoke_jjjj = "5n",
  invoke_jjjji = "5o",
  invoke_jjjjiijii = "5p",
  invoke_jjjjj = "5q",
  invoke_jjjjji = "5r",
  invoke_jjjjjj = "5s",
  invoke_viiiiiijji = "5t",
  invoke_viiiijjjij = "5u",
  invoke_viiijjji = "5v",
  invoke_viijj = "5w",
  invoke_viijjiiiiiiijiijiiiii = "5x",
  invoke_vijjj = "5y",
  invoke_vijjji = "5z",
  invoke_vijjjij = "60",
  invoke_vj = "61",
  invoke_vji = "62",
  invoke_vjii = "63",
  invoke_vjiiii = "64",
  invoke_vjiiiiiiiiiiijjiiijiiijijijjiiiiijiiiijj = "65",
  invoke_vjiiiiiiiijjjjj = "66",
  invoke_vjiiiij = "67",
  invoke_vjiij = "68",
  invoke_vjiijiii = "69",
  invoke_vjiijj = "6a",
  invoke_vjij = "6b",
  invoke_vjijj = "6c",
  invoke_vjijjjj = "6d",
  invoke_vjj = "6e",
  invoke_vjji = "6f",
  invoke_vjjii = "6g",
  invoke_vjjiii = "6h",
  invoke_vjjiiiijj = "6i",
  invoke_vjjiiij = "6j",
  invoke_vjjiiijj = "6k",
  invoke_vjjij = "6l",
  invoke_vjjiji = "6m",
  invoke_vjjijj = "6n",
  invoke_vjjj = "6o",
  invoke_vjjji = "6p",
  invoke_vjjjii = "6q",
  invoke_vjjjiii = "6r",
  invoke_vjjjijji = "6s",
  invoke_vjjjj = "6t",
  invoke_vjjjji = "6u",
  invoke_vjjjjii = "6v",
  invoke_vjjjjiij = "6w",
  invoke_vjjjjiijj = "6x",
  invoke_vjjjjij = "6y",
  invoke_vjjjjj = "6z",
  dynCall_ii = "70",
  dynCall_iii = "71",
  dynCall_iiii = "72",
  dynCall_iiiii = "73",
  dynCall_iiiiii = "74",
  dynCall_iiiiiii = "75",
  dynCall_iiiiiiii = "76",
  dynCall_iiiiiiiii = "77",
  dynCall_iiiiiiiiii = "78",
  dynCall_iiiiiiiiiiii = "79",
  dynCall_v = "7a",
  dynCall_vi = "7b",
  dynCall_vii = "7c",
  dynCall_viii = "7d",
  dynCall_viiii = "7e",
  dynCall_viiiii = "7f",
  dynCall_viiiiii = "7g",
  dynCall_viiiiiii = "7h",
  dynCall_viiiiiiii = "7i",
  dynCall_viiiiiiiii = "7j",
  dynCall_iiji = "7k",
  dynCall_iji = "7l",
  dynCall_jji = "7m",
  dynCall_jiji = "7n",
  dynCall_iij = "7o",
  dynCall_jii = "7p",
  dynCall_ji = "7q",
  dynCall_diiid = "7r",
  dynCall_iidi = "7s",
  dynCall_iddii = "7t",
  dynCall_iiiiiij = "7u",
  dynCall_iiiiiiiiiijj = "7v",
  dynCall_iiiiiiiiiiji = "7w",
  dynCall_iiiiiiijjii = "7x",
  dynCall_iijiii = "7y",
  dynCall_iiijiii = "7z",
  dynCall_iiiijj = "80",
  dynCall_iidiii = "81",
  dynCall_fdi = "82",
  dynCall_idii = "83",
  dynCall_iiiiiiiifi = "84",
  dynCall_vijii = "85",
  dynCall_iiiijii = "86",
  dynCall_iiiiijiiiii = "87",
  dynCall_fdii = "88",
  dynCall_viiiiiiiiijiiii = "89",
  dynCall_id = "8a",
  dynCall_dd = "8b",
  dynCall_viij = "8c",
  dynCall_fdd = "8d",
  dynCall_iiiij = "8e",
  dynCall_iiiiijiiii = "8f",
  dynCall_iiijii = "8g",
  dynCall_iiiijiiii = "8h",
  dynCall_iiiji = "8i",
  dynCall_iidiiii = "8j",
  dynCall_iijii = "8k",
  dynCall_iijj = "8l",
  dynCall_iijjjjjj = "8m",
  dynCall_viiiiiiiiiiiiiijiiiii = "8n",
  dynCall_viiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiijiiiiii = "8o",
  dynCall_iiiiiiiiiiiiiiiii = "8p",
  dynCall_iiiiiiiiiiiiii = "8q",
  dynCall_iiiiiiiiiiiii = "8r",
  dynCall_iiiiiiiiiiiiiiii = "8s",
  dynCall_iiiiiiiiiii = "8t",
  dynCall_iiiiiiiiiiiiiii = "8u",
  dynCall_djijd = "8v",
  dynCall_fdj = "8w",
  dynCall_fdjj = "8x",
  dynCall_iddjj = "8y",
  dynCall_idjj = "8z",
  dynCall_iidjjj = "90",
  dynCall_iijjj = "91",
  dynCall_ij = "92",
  dynCall_ijdj = "93",
  dynCall_ijii = "94",
  dynCall_ijiii = "95",
  dynCall_ijiiii = "96",
  dynCall_ijiiiiiii = "97",
  dynCall_ijiiiiiiji = "98",
  dynCall_ijiiiij = "99",
  dynCall_ijiiiijiii = "9a",
  dynCall_ijiiiijij = "9b",
  dynCall_ijiiij = "9c",
  dynCall_ijiiijjiiiiii = "9d",
  dynCall_ijiij = "9e",
  dynCall_ijiiji = "9f",
  dynCall_ijiijj = "9g",
  dynCall_ijij = "9h",
  dynCall_ijiji = "9i",
  dynCall_ijijijj = "9j",
  dynCall_ijijj = "9k",
  dynCall_ijijjj = "9l",
  dynCall_ijijjjj = "9m",
  dynCall_ijj = "9n",
  dynCall_ijji = "9o",
  dynCall_ijjii = "9p",
  dynCall_ijjiiiij = "9q",
  dynCall_ijjiiiijjii = "9r",
  dynCall_ijjiiij = "9s",
  dynCall_ijjiiijjji = "9t",
  dynCall_ijjiij = "9u",
  dynCall_ijjiijiiii = "9v",
  dynCall_ijjiijiiiii = "9w",
  dynCall_ijjiijiiiiji = "9x",
  dynCall_ijjiijiiiijii = "9y",
  dynCall_ijjiijiiiijiij = "9z",
  dynCall_ijjiijiiiijj = "a0",
  dynCall_ijjiijjjjiiiiiiii = "a1",
  dynCall_ijjiijjjjjjjiiii = "a2",
  dynCall_ijjij = "a3",
  dynCall_ijjiji = "a4",
  dynCall_ijjijiii = "a5",
  dynCall_ijjijj = "a6",
  dynCall_ijjijjj = "a7",
  dynCall_ijjj = "a8",
  dynCall_ijjji = "a9",
  dynCall_ijjjii = "aa",
  dynCall_ijjjiiiiiiii = "ab",
  dynCall_ijjjiiiji = "ac",
  dynCall_ijjjiiijj = "ad",
  dynCall_ijjjij = "ae",
  dynCall_ijjjijj = "af",
  dynCall_ijjjijji = "ag",
  dynCall_ijjjj = "ah",
  dynCall_ijjjji = "ai",
  dynCall_ijjjjii = "aj",
  dynCall_ijjjjj = "ak",
  dynCall_ijjjjji = "al",
  dynCall_ijjjjjij = "am",
  dynCall_ijjjjjj = "an",
  dynCall_ijjjjjji = "ao",
  dynCall_ijjjjjjiij = "ap",
  dynCall_ijjjjjjijii = "aq",
  dynCall_ijjjjjjj = "ar",
  dynCall_ijjjjjjjfj = "as",
  dynCall_ijjjjjjjj = "at",
  dynCall_ijjjjjjjji = "au",
  dynCall_ijjjjjjjjj = "av",
  dynCall_ijjjjjjjjjj = "aw",
  dynCall_ijjjjjjjjjjj = "ax",
  dynCall_ijjjjjjjjjjjjj = "ay",
  dynCall_ijjjjjjjjjjjjjj = "az",
  dynCall_jj = "b0",
  dynCall_jjii = "b1",
  dynCall_jjiii = "b2",
  dynCall_jjiiiii = "b3",
  dynCall_jjiijj = "b4",
  dynCall_jjij = "b5",
  dynCall_jjijjjji = "b6",
  dynCall_jjj = "b7",
  dynCall_jjji = "b8",
  dynCall_jjjiii = "b9",
  dynCall_jjjiijjj = "ba",
  dynCall_jjjj = "bb",
  dynCall_jjjji = "bc",
  dynCall_jjjjiijii = "bd",
  dynCall_jjjjj = "be",
  dynCall_jjjjji = "bf",
  dynCall_jjjjjj = "bg",
  dynCall_viiiiiijji = "bh",
  dynCall_viiiijjjij = "bi",
  dynCall_viiijjji = "bj",
  dynCall_viijj = "bk",
  dynCall_viijjiiiiiiijiijiiiii = "bl",
  dynCall_vijjj = "bm",
  dynCall_vijjji = "bn",
  dynCall_vijjjij = "bo",
  dynCall_vj = "bp",
  dynCall_vji = "bq",
  dynCall_vjii = "br",
  dynCall_vjiiii = "bs",
  dynCall_vjiiiiiiiiiiijjiiijiiijijijjiiiiijiiiijj = "bt",
  dynCall_vjiiiiiiiijjjjj = "bu",
  dynCall_vjiiiij = "bv",
  dynCall_vjiij = "bw",
  dynCall_vjiijiii = "bx",
  dynCall_vjiijj = "by",
  dynCall_vjij = "bz",
  dynCall_vjijj = "c0",
  dynCall_vjijjjj = "c1",
  dynCall_vjj = "c2",
  dynCall_vjji = "c3",
  dynCall_vjjii = "c4",
  dynCall_vjjiii = "c5",
  dynCall_vjjiiiijj = "c6",
  dynCall_vjjiiij = "c7",
  dynCall_vjjiiijj = "c8",
  dynCall_vjjij = "c9",
  dynCall_vjjiji = "ca",
  dynCall_vjjijj = "cb",
  dynCall_vjjj = "cc",
  dynCall_vjjji = "cd",
  dynCall_vjjjii = "ce",
  dynCall_vjjjiii = "cf",
  dynCall_vjjjijji = "cg",
  dynCall_vjjjj = "ch",
  dynCall_vjjjji = "ci",
  dynCall_vjjjjii = "cj",
  dynCall_vjjjjiij = "ck",
  dynCall_vjjjjiijj = "cl",
  dynCall_vjjjjij = "cm",
  dynCall_vjjjjj = "cn",
}
